/* eslint-disable no-restricted-globals */
import React, { useState } from "react";
import AppButton from "../../common/AppButton";
import config from "../../config/config";
import colors from "../../config/colors";
import AppInput from "../../common/AppInput";
import { cloneDeep } from "lodash";
import numberOnly from "../../common/numberOnly";
import api from "../../config/api";
import DayTimeSlots from "../../components/DayTimeSlots";
import LabelText from "../../common/LabelText";
import { Modal } from "react-bootstrap";
import { FaUserTie } from "react-icons/fa";
import { RiPhoneFill } from "react-icons/ri";
import { IoLocationSharp } from "react-icons/io5";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

const size = config.iconSize;

export default function EmployeeViewModel() {
  const [, setDisabled] = useState(false);
  const queryClient = useQueryClient();

  const Body = ({ onDone, employee }) => {
    const [editable, setEditable] = useState(false);
    const [form, setForm] = useState(
      cloneDeep({ ...employee, type: { name: employee.type } })
    );
    const handleSubmit = async (event) => {
      event.preventDefault();
      const error = ["type"].reverse().filter((item) => {
        if (!form[item] || form[item]?.length === 0) {
          document.querySelector("#" + item + " input").focus();
          return item;
        }
        return false;
      });

      if (error.length > 0) return false;
      form.availability = Object.values(form.availability).filter(
        (i) => i.available
      );

      const res = await api.put("employees", {
        ...form,
        _id: employee._id,
        type: form.type.name,
      });
      if (!res.ok) {
        setDisabled(false);
        return toast.error(res.originalError.message);
      }
      queryClient.invalidateQueries(["employees"]);

      setDisabled(false);
      toast.success("Changes have been successfully updated.");

      onDone && onDone();
    };
    const handleChange = ({ target }) => {
      const name = target.name;
      const value = target.value;
      setDisabled(false);
      setForm({ ...form, [name]: value });
    };

    const handleRemove = async () => {
      if (confirm("Are you sure want to remove employee ?") === false)
        return false;
      const res = await api.put("employees", {
        _id: employee._id,
        isDeleted: true,
      });
      if (!res.ok) return toast.error(res.originalError.message);
      queryClient.invalidateQueries(["employees"]);

      onDone && onDone();
      toast.success("Employee has been successfully removed.");
    };

    return (
      <React.Fragment>
        <Modal.Header closeButton>
          <div
            className="d-flex"
            style={{ justifyContent: "space-between", width: "100%" }}
          >
            <span className="d-flex" style={{ alignItems: "center" }}>
              <b>Employee Details</b>
            </span>
            {!editable && (
              <AppButton
                onClick={() => {
                  setEditable(true);
                }}
                text="Edit"
                className="text-primary"
              />
            )}
            {editable && (
              <AppButton
                onClick={handleRemove}
                text="Remove"
                className="text-danger"
              />
            )}
          </div>
        </Modal.Header>
        <Modal.Body style={{ overflowY: "auto" }}>
          <form id="form" onSubmit={handleSubmit}>
            <div
              className="d-flex"
              style={{
                gap: "20px",
                padding: "0px 30px 0px 30px",
              }}
            >
              <AppInput
                onChange={handleChange}
                leftIcon={<FaUserTie size={size} color={colors.silver} />}
                label="Name"
                floatLabel
                name="name"
                showMode={!editable}
                value={form.name}
                required
              />
              <AppInput
                leftIcon={<RiPhoneFill size={size} color={colors.silver} />}
                label="Contact"
                floatLabel
                onChange={handleChange}
                showMode={!editable}
                name="contact"
                type="tel"
                value={numberOnly(form.contact)}
                required
              />
              <AppInput
                onChange={handleChange}
                leftIcon={<IoLocationSharp size={size} color={colors.silver} />}
                id="type"
                label="Type"
                floatLabel
                type="dropdown"
                showMode={!editable}
                name="type"
                options={[
                  { name: "Casual" },
                  { name: "Regular" },
                  { name: "Subcontractor" },
                ]}
                filterBy="name"
                value={form.type}
              />
            </div>
            <br />
            <br />
            <div className="d-flex " style={{ gap: 40, padding: "0px 30px" }}>
              <div>
                <LabelText label="Availability" />
                <DayTimeSlots
                  showMode={!editable}
                  defaultValue={employee.availability}
                  onChange={(dt) => {
                    setForm({ ...form, availability: dt });
                  }}
                />
              </div>
            </div>
            <br />
            <br />
            <br />
          </form>
        </Modal.Body>
        {editable && (
          <Modal.Footer>
            <AppButton
              form="form"
              text="Save"
              type="submit"
              className="text-primary"
            />
          </Modal.Footer>
        )}
      </React.Fragment>
    );
  };

  return { Body };
}
